/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'
import { MyProfileListMode } from '../enums/myprofile-list-component-mode'
import { PhoneCommunicationDto } from '../../../../../apps/myprofile-ui/src/app/services/phone/phone.service'

@Injectable({
  providedIn: 'root',
})
export class ListHelperService {
  static isEditMode(mode: MyProfileListMode, itemBeingEdited: any) {
    if (!itemBeingEdited) {
      return false
    }

    // If mode is ALL, show the editor 'cause we only got one slot to mount the editor anyways
    if (mode === MyProfileListMode.ALL) {
      return true
    }

    // Depending on the mode and the Id we select whether we should show the editor or not
    return (
      (itemBeingEdited.isStandard && mode === MyProfileListMode.ONLY_STANDARD) ||
      (!itemBeingEdited.isStandard && mode === MyProfileListMode.ONLY_ADDITIONAL)
    )
  }

  static sortPhonesByDefaultFlag(phones: PhoneCommunicationDto[]): PhoneCommunicationDto[] {
    phones = phones.sort((p1, _) => {
      if (p1.isStandard) {
        return -1
      } else {
        return 1
      }
    })

    return phones
  }

  getItemsAccordingToListMode(mode: MyProfileListMode, items: PhoneCommunicationDto[]) {
    switch (mode) {
      case MyProfileListMode.ONLY_STANDARD:
        return items.filter((phone) => phone.isStandard)
      case MyProfileListMode.ONLY_ADDITIONAL:
        items = items.filter((phone) => !phone.isStandard)
        return this.sortPhonesByType(items)
      default:
        return this.sortPhones(items)
    }
  }

  sortPhones(phones: PhoneCommunicationDto[]): PhoneCommunicationDto[] {
    phones = this.sortPhonesByType(phones)
    phones = ListHelperService.sortPhonesByDefaultFlag(phones)
    return phones
  }

  sortPhonesByType(phones: PhoneCommunicationDto[]): PhoneCommunicationDto[] {
    phones = phones.slice().sort((p1) => {
      if (p1.phoneType === 'mobile') {
        return -1
      } else {
        return 1
      }
    })

    return phones
  }
}
